// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
// import axios from 'axios'

import apiHandle from '../../../../configs/apiConfig'

export const requestApprove = createAsyncThunk('request/approve', async (params) => {
  const response = await apiHandle('POST', 'request/approve', params)
  return response
})
export const requestCreate = createAsyncThunk('request/applicationfee/create', async (params) => {
  const response = await apiHandle('POST', 'applicationfee/create', params)
  return response
})
export const getDataTable = createAsyncThunk('request/getDataTable', async (params) => {
  const response = await apiHandle('GET', 'request/gettable', params)
  return response
})
export const requestReaderCard = createAsyncThunk('request/requestReaderCard', async () => {
  const response = await apiHandle('GET', 'mockreadercard')
  return response
})
export const requestCheckExsit = createAsyncThunk('request/requestCheckExsit', async (params) => {
  const response = await apiHandle('GET', 'customer/check', params)
  return response
})

export const requestDataDetail = createAsyncThunk('request/requestDataDetail', async (params) => {
  const response = await apiHandle('GET', 'applicationfee/get', params)
  return response
})

export const requestGetCourse = createAsyncThunk('request/requestGetCourse', async (params) => {
  const response = await apiHandle('GET', 'application/getforregister', params)
  return response
})

export const requestPDFPaymentCreate = createAsyncThunk('request/applicationfee/pdfpayment/create', async (params) => {
  const response = await apiHandle('POST', 'applicationfee/pdfpayment', params)
  return response
})

export const requestPDFCreate = createAsyncThunk('request/applicationfee/pdf/create', async (params) => {
  const response = await apiHandle('POST', 'applicationfee/pdf', params)
  return response
})


const defaultCoruseCost = {
  course_id: '',
  course_name: null,
  promotion_code: null,
  exam_date: null,
  cost: null,
  discount: null,
  paid: null,
  pay_type: null
}

const defaultRequestCost = {
  request_fee_id: null,
  request_fee_name: null,
  promotion_code: null,
  exam_date: null,
  cost: null,
  discount: null,
  paid: null,
  pay_type: null
}

const defaultPayments = {
  payment_id: null,
  payment_code: null,
  pay_type: null,
  paid: null,
  createdAt: null
}


const defaultReisterDetail = {
  is_foreigner: false,
  prefix: '',
  name: '',
  idcard: '',
  birthday: null,
  address: null,
  moo: '',
  soi: '',
  street: '',
  subdistrict: '',
  district: '',
  province: '',
  phone_1: '',
  phone_2: '',
  age: '',
  course: [defaultCoruseCost],
  request_fee: [defaultRequestCost],
  payments: [defaultPayments],
  paid: '',
  discount: '',
  net: '',
  balance: '',
  total: '',
  // pay_type: 'เงินสด',
  status: null,
  application_code: null,
  request_fee_id: '',
  createStatus: false,
  application_id: null,
  application_request_fee_code:null
}


export const requestSlice = createSlice({
  name: 'request',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedData: null,
    searchCriteria: {
      branch: { label: 'ทั้งหมด', value: 'ทั้งหมด' },
      status: { label: 'ทั้งหมด', value: 'ทั้งหมด' },
      type: { label: 'ทั้งหมด', value: 'ทั้งหมด' },
      text: ''
    },
    requestData: {
      data: [],
      filter: {
        branch: [],
        status: [],
        type: []
      },
      meta: {},
      isLoading: false
    },
    requestDetail: {
      isEdit: false,
      dropdown: {
        course: [],
        request_fee: []
      },
      userData: defaultReisterDetail
    },
    alert:{
      active:false,
      message:'',
      err : false
    }
  },
  reducers: {
    searchCriteria: (state, action) => {
      if (action.type === 'request/searchCriteria') {
        state.searchCriteria[action.payload.target] = action.payload.value
      }
    },
    requestNew: (state, action) => {
      if (action.type === 'request/requestNew') {
        state.requestDetail.isEdit = false
        state.requestDetail.userData = defaultReisterDetail
      }
    },
    requestAddHandle: (state, action) => {
      console.log(action)
      if (action.type === 'request/requestAddHandle') {
        if (action.payload.target === 'course') {
          state.requestDetail.userData.course.push(defaultCoruseCost)
        }
        if (action.payload.target === 'request') {
          state.requestDetail.userData.request_fee.push(defaultRequestCost)
        }

      }
    },
    requestDeleteHandle: (state, action) => {
      if (action.type === 'request/requestDeleteHandle') {
        if (action.payload.target === 'course') {
          state.requestDetail.userData.course.splice(action.payload.index, 1)
        }
        if (action.payload.target === 'request') {
          state.requestDetail.userData.request_fee.splice(action.payload.index, 1)
        }

      }

    },
    requestDropdownHandle: (state, action) => {
      if (action.type === 'request/requestDropdownHandle') {
        if (action.payload.target === 'course' && state.requestDetail.isEdit === false) {
          state.requestDetail.userData.course[action.payload.index].course_id = action.payload.value.course_id
          state.requestDetail.userData.course[action.payload.index].course_name = action.payload.value.name
          state.requestDetail.userData.course[action.payload.index].cost = action.payload.value.price
        }
        if (action.payload.target === 'examDate') {
          state.requestDetail.userData.course[action.payload.index].exam_date = action.payload.value
        }
        if (action.payload.target === 'request' && state.requestDetail.isEdit === false) {
          state.requestDetail.userData.request_fee[action.payload.index].request_fee_id = action.payload.value.request_fee_id
          state.requestDetail.userData.request_fee[action.payload.index].request_fee_name = action.payload.value.name
          state.requestDetail.userData.request_fee[action.payload.index].cost = action.payload.value.price
        }
        if (action.payload.target === 'pay_type') {
          state.requestDetail.userData[action.payload.mode][action.payload.index].pay_type = action.payload.value
        }
      }
    },
    requestOnChangeHandle: (state, action) => {
      if (action.type === 'request/requestOnChangeHandle') {
        if (action.payload.target === 'paid') {
          state.requestDetail.userData[action.payload.mode][action.payload.index][action.payload.target] = action.payload.value
        } else {
          state.requestDetail.userData[action.payload.target] = action.payload.value
        }

      }
    },
    requestLoading: (state, action) => {
      if (action.type === 'request/requestLoading') {
        state.requestData.isLoading = true
      }
    },
    requestAlert: (state, action) => {
      if (action.type === 'request/requestAlert') {
        state.alert.active = false
        state.alert.message = ''
        state.alert.err = false
      }
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getDataTable.fulfilled, (state, action) => {
        console.log(action)
        if (action.type === 'request/getDataTable/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            state.requestData = action.payload
            state.requestData.isLoading = false
          }
        }
      })
      .addCase(requestApprove.fulfilled, (state, action) => {
        if (action.type === 'request/approve/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
            state.alert.active = true
            state.alert.err = true
            state.alert.message = action.payload.message
          } else {
            state.alert.active = true
            state.alert.message = action.payload.message
          }
        }
      })
      .addCase(requestReaderCard.fulfilled, (state, action) => {
        if (action.type === 'request/requestReaderCard/fulfilled') {
          if (action.payload.result === 'ok') {
            state.requestDetail.userData.prefix = action.payload.title_th
            state.requestDetail.userData.name = `${action.payload.fname_th} ${action.payload.sname_th}`
            state.requestDetail.userData.idcard = action.payload.nat_id
            state.requestDetail.userData.birthday = action.payload.birthdate
            state.requestDetail.userData.address = action.payload.address_no
            state.requestDetail.userData.street = action.payload.address_road
            state.requestDetail.userData.province = action.payload.address_provinice
            state.requestDetail.userData.district = action.payload.address_amphor
            state.requestDetail.userData.subdistrict = action.payload.address_tumbol
            state.requestDetail.userData.age = null

          } else {
            //handleError
          }
        }
      })
      .addCase(requestDataDetail.fulfilled, (state, action) => {
        if (action.type === 'request/requestDataDetail/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            state.requestDetail.isEdit = true
            state.requestDetail.userData.prefix = action.payload.data.customer.prefix ? action.payload.data.customer.prefix : ''
            state.requestDetail.userData.name = action.payload.data.customer.name ? action.payload.data.customer.name : ''
            state.requestDetail.userData.idcard = action.payload.data.customer.idcard ? action.payload.data.customer.idcard : ''
            state.requestDetail.userData.birthday = action.payload.data.customer.birthday ? action.payload.data.customer.birthday : null
            state.requestDetail.userData.address = action.payload.data.customer.address ? action.payload.data.customer.address : ''
            state.requestDetail.userData.moo = action.payload.data.customer.moo ? action.payload.data.customer.moo : ''
            state.requestDetail.userData.soi = action.payload.data.customer.soi ? action.payload.data.customer.soi : ''
            state.requestDetail.userData.street = action.payload.data.customer.street ? action.payload.data.customer.street : ''
            state.requestDetail.userData.province = action.payload.data.customer.province ? action.payload.data.customer.province : ''
            state.requestDetail.userData.district = action.payload.data.customer.district ? action.payload.data.customer.district : ''
            state.requestDetail.userData.subdistrict = action.payload.data.customer.subdistrict ? action.payload.data.customer.subdistrict : ''
            state.requestDetail.userData.phone_1 = action.payload.data.customer.phone_1 ? action.payload.data.customer.phone_1 : ''
            state.requestDetail.userData.phone_2 = action.payload.data.customer.phone_2 ? action.payload.data.customer.phone_2 : ''
            state.requestDetail.userData.status = action.payload.data.status ? action.payload.data.status : null
            state.requestDetail.userData.application_request_fee_code = action.payload.data.application_request_fee_code ? action.payload.data.application_request_fee_code : null
            state.requestDetail.userData.paid = action.payload.data.paid === 0 ? '0' : action.payload.data.paid.toString()
            state.requestDetail.userData.request_fee_id = action.payload.data.request_fee_id ? action.payload.data.request_fee_id.toString() : ''
            state.requestDetail.userData.discount = action.payload.data.discount === 0 ? '0' : action.payload.data.discount.toString()
            state.requestDetail.userData.net = action.payload.data.net === 0 ? '0' : action.payload.data.net.toString()
            state.requestDetail.userData.balance = action.payload.data.balance === 0 ? '0' : action.payload.data.balance.toString()
            state.requestDetail.userData.total = action.payload.data.total === 0 ? '0' : action.payload.data.total.toString()
            state.requestDetail.userData.application_id = action.payload.data.application_request_fee_id
            state.requestDetail.userData.payments = action.payload.data.payments
            state.requestDetail.userData.request_fee = [
              {
                request_fee_id: action.payload.data.request_fee_id ? action.payload.data.request_fee_id.toString() : '',
                request_fee_name: null,
                promotion_code: null,
                exam_date: null,
                cost: action.payload.data.balance ? action.payload.data.balance.toString() : '',
                discount: null,
                paid: null,
                pay_type: null
              }
            ]
          }
        }
      })
      .addCase(requestCheckExsit.fulfilled, (state, action) => {
        if (action.type === 'request/requestCheckExsit/fulfilled') {
          console.log(action)
          if (action.payload.status === 'success') {
            if (action.payload.data) {
              state.requestDetail.userData.prefix = action.payload.data.prefix ? action.payload.data.prefix : ''
              state.requestDetail.userData.name = action.payload.data.name ? action.payload.data.name : ''
              state.requestDetail.userData.idcard = action.payload.data.idcard ? action.payload.data.idcard : ''
              state.requestDetail.userData.birthday = action.payload.data.birthday ? action.payload.data.birthday : null
              state.requestDetail.userData.address = action.payload.data.address ? action.payload.data.address : ''
              state.requestDetail.userData.moo = action.payload.data.moo ? action.payload.data.moo : ''
              state.requestDetail.userData.soi = action.payload.data.soi ? action.payload.data.soi : ''
              state.requestDetail.userData.street = action.payload.data.street ? action.payload.data.street : ''
              state.requestDetail.userData.province = action.payload.data.province ? action.payload.data.province : ''
              state.requestDetail.userData.district = action.payload.data.district ? action.payload.data.district : ''
              state.requestDetail.userData.subdistrict = action.payload.data.subdistrict ? action.payload.data.subdistrict : ''
              state.requestDetail.userData.phone_1 = action.payload.data.phone_1 ? action.payload.data.phone_1 : ''
              state.requestDetail.userData.phone_2 = action.payload.data.phone_2 ? action.payload.data.phone_2 : ''
            } else {

            }

          } else {
            //handleError
          }
        }
      })
      .addCase(requestGetCourse.fulfilled, (state, action) => {
        if (action.type === 'request/requestGetCourse/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            state.requestDetail.dropdown.course = action.payload.course
            state.requestDetail.dropdown.request_fee = action.payload.request_fee
          }
        }
      })
      .addCase(requestPDFCreate.fulfilled, (state, action) => {
        console.log(action)
        if (action.type === 'request/applicationfee/pdf/create/fulfilled') {
          console.log(action)
          if (action.payload.status === 'success') {
            console.log(action)
            window.open(action.payload.data.pdf, '_blank')
          } else {
            //handleError
          }
        }
      })
      .addCase(requestPDFPaymentCreate.fulfilled, (state, action) => {
        if (action.type === 'request/applicationfee/pdfpayment/create/fulfilled') {
          if (action.payload.status === 'success') {
            window.open(action.payload.data.pdf, '_blank')
          } else {
            //handleError
          }
        }
      })
  }
})

export const { searchCriteria, requestNew, requestAddHandle, requestDropdownHandle, requestDeleteHandle, requestOnChangeHandle, requestLoading, requestAlert } = requestSlice.actions

export default requestSlice.reducer
